// extracted by mini-css-extract-plugin
export default {"container":"expenses_settings_container__drhME","colorDot":"expenses_settings_colorDot__ksfCM"};